module.exports = __webpack_public_path__ + "static/media/bea7eba5-0f6c-4c5a-bc8e-7944fa42ab82.3d5cac12.JPG";